<template>
  <div>
    <TplListBasic :title="title(routeName)" :bgcolorClass="bgClass(routeName)">
      <template v-slot:sheet-tags>
        <div class="tags-container">
          <OrderTag :status="status" />
          <OrderTag v-if="closure== 'Closed'" :status="closure" />
          <el-tag type="success" v-if="xeroSent=='Sent'" size="medium">Xero {{xeroSent}}</el-tag>
          <el-tag type="danger" v-if="xeroSent=='Fail'" size="medium">Xero {{xeroSent}}</el-tag>
          <el-tag
            type="warning"
            v-if="xeroSent!=='Fail'&&xeroSent!=='Sent'"
            size="medium"
          >Xero {{xeroSent}}</el-tag>
          <el-tag type="success" v-if="showPrint" size="medium" color="#BFE0E0">{{print}}</el-tag>
        </div>
      </template>
      <template v-slot:actions>
        <div class="actions-btns-container">
          <div class="actions-btns-container">
            <el-button
              v-if="btnShow('sendXero')"
              class="btn"
              type="success"
              plain
              @click="handleSendXero"
            >SendXero</el-button>
            <el-button
              v-if="btnShow('xeroRecall')"
              class="btn"
              type="success"
              plain
              @click="markAsUnsend"
            >XeroRecall</el-button>
            <el-button
              v-if="btnShow('void')"
              class="btn"
              type="danger"
              plain
              @click="handleVoid"
            >Void</el-button>
            <btn-print v-if="btnShow('print')" :orderNo="id"></btn-print>
            <btn-edit
              v-if="btnShow('edit')"
              :canModifyContent="canModifyContent"
              :canModifyDate="canModifyDate"
              :canModifyAddress="canModifyAddress"
              :canModifyDriver="canModifyDriver"
            ></btn-edit>
            <el-button
              v-if="btnShow('approve')"
              class="btn"
              type="primary"
              @click="handleApprove"
            >Approve</el-button>
            <el-button
              v-if="btnShow('unapprove')"
              class="btn"
              type="primary"
              @click="handleUnApprove"
            >UnApprove</el-button>
            <el-button v-if="btnShow('close')" class="btn" type="primary" @click="handleClose">Close</el-button>
          </div>
        </div>
      </template>
      <template v-slot:search>
        <OrderInputs :isEdit="false" :config="config" />
      </template>
      <template v-slot:results>
        <OrderLinesEdit :isEdit="false" :config="lineConfig" />
      </template>
    </TplListBasic>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import TplListBasic from '../components/TplListBasic'
import OrderInputs from '../components/OrderInputs'
import OrderLinesEdit from '../components/OrderLinesEdit'
import BtnEdit from '../components/BtnEdit'
import BtnPrint from '../components/BtnPrint'
import OrderTag from '../components/OrderTags'

export default {
  name: 'OrderDetail',
  components: {
    TplListBasic,
    OrderInputs,
    OrderLinesEdit,
    BtnEdit,
    BtnPrint,
    OrderTag
    // CartSimple
  },
  created () {
    this.routeName = this.$route.params.routeName

    // this.setId(this.$route.params.id)
    // if (this.$route.name == 'OrderAdd') {
    //   this.init({routeName: this.routeName, opType: 'draft'});
    // }
    this.init(this.$route.params.id)
  },
  data () {
    return {
      // bus: new Vue(),
      routeName: ''
    }
  },
  computed: {
    ...mapState('config', {
      config: 'inputs',
      lineConfig: 'lines'
    }),
    ...mapState('edit', {
      id: 'id',
      no: 'no',
      paymentType: 'paymentType',
      orderType: 'type',
      status: 'status',
      closure: 'closure',
      xeroSent: 'xeroSent',
      print: 'print',
      csrCreditLimit: 'csrCreditLimit',
      csrXeroBalance: 'csrXeroBalance',
      lines: 'lines'
    }),
    ...mapGetters({
      bgClass: 'prefs/searchBgClass',
      title: 'prefs/getPageTitle',
      btnShow: 'edit/btnShow',
      canModifyContent: 'edit/canModifyContent',
      getRouteName: 'getRouteNameFromOrderType'
    }),
    canModifyDate () {
      return this.status !== 'Voided'
    },
    canModifyAddress () {
      return (
        this.canModifyDate && (this.orderType === 1 || this.orderType === 2)
      )
    },
    canModifyDriver () {
      return (
        (this.orderType === 1 || this.orderType === 2) &&
        this.status === 'Approved'
      )
    },
    showPrint () {
      return (
        (this.orderType === 1 || this.orderType === 2) &&
        this.status === 'Approved'
      )
    }
  },
  methods: {
    ...mapMutations({
      setId: 'edit/setId'
    }),
    ...mapActions({
      // init: "edit/init",
      init: 'edit/initShow',
      approve: 'edit/handleApprove',
      unApprove: 'edit/handleUnApprove',
      close: 'edit/handleClose',
      void: 'edit/handleVoid',
      sendXero: 'edit/sendXero',
      recallFromXero: 'edit/recallFromXero'
    }),
    handleApprove () {
      const role = Number.parseInt(localStorage.getItem('role') || 0)
      const roleObj = JSON.parse(localStorage.getItem('role-fone') || '{}')
      const isAccountant = !!roleObj.isAcct
      const csrCreditLimit = Number.parseInt(this.csrCreditLimit)
      const csrXeroBalance = Number.parseFloat(this.csrXeroBalance)
      const lower10lineNo = this.lines.findIndex(i => i.price < (i.product.classAPrice - 9))
      const confirmParam = {
        distinguishCancelAndClose: true,
        confirmButtonText: 'Comfirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }
      // 实际审核前增加creditLimit判断，CBD判断，低于10刀判断
      const JudgeLower10 = this.orderType === 1 && lower10lineNo !== -1
      const JudgeCreditLimit = this.orderType === 1 && csrCreditLimit !== 0 && csrXeroBalance > csrCreditLimit
      const JudgeIsCBD = this.orderType === 1 && this.paymentType === 'CBD'
      const MessageLower10 = `The price of line ${lower10lineNo + 1} is $10 (or more) lower than PriceA.`
      const MessageCreditLimit = `Current Xero Balance ${csrXeroBalance} greater than his Limit ${csrCreditLimit}`
      const MessageIsCBD = `This is CBD (Cash Before Delivery) customer.`

      if (role !== 4) {
        if (JudgeLower10) {
          this.$message({ message: MessageLower10 + ' Contact manager.', type: 'warning' })
          return
        } else if (JudgeCreditLimit) {
          this.$message({ message: MessageCreditLimit + ' Contact manager.', type: 'warning' })
          return
        } else if (JudgeIsCBD) {
          this.$message({ message: MessageIsCBD + ' Contact manager.', type: 'warning' })
          return
        }
        this._approveAction()
      }

      if (role === 4 && !isAccountant && JudgeIsCBD) { // 非会计人员不能审核CBD
        this.$message({ message: 'You need Accountant-Permit. And' + MessageIsCBD, type: 'warning' })
        return
      }

      if (role === 4) {
        let allMessage = []
        if (JudgeLower10) {
          allMessage.push(MessageLower10)
        }
        if (JudgeCreditLimit) {
          allMessage.push(MessageCreditLimit)
        }
        if (JudgeIsCBD) {
          allMessage.push(MessageIsCBD)
        }
        if (allMessage.length > 0) {
          let message = allMessage.join(' *AND* ') + ' Approve now?'
          this.$confirm(
            message,
            'Confirm Approve',
            confirmParam
          ).then(() => {
            this._approveAction()
          }).catch(() => {})
        } else {
          this._approveAction()
        }
      }
    },

    _approveAction () {
      const loading = this.$loading({
        lock: true,
        text: 'Processing',
        spinner: 'el-icon-loading'
      })
      this.approve()
        .then(data => {
          loading.close()
          this.success(data.id)
        })
        .catch(() => loading.close())
    },
    handleUnApprove () {
      const loading = this.$loading({
        lock: true,
        text: 'Processing',
        spinner: 'el-icon-loading'
      })
      this.unApprove()
        .then(data => {
          loading.close()
          this.success(data.id)
        })
        .catch(() => loading.close())
    },
    handleVoid () {
      this.$confirm(
        `Are you sure to VOID? This operation cannot be undone!`,
        'Confirm Void',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: 'Comfirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      ).then(() => {
        const loading = this.$loading({
          lock: true,
          text: 'Processing',
          spinner: 'el-icon-loading'
        })
        this.void()
          .then(data => {
            loading.close()
            this.success(data.id)
          })
          .catch(() => loading.close())
      })
    },
    handleClose () {
      const loading = this.$loading({
        lock: true,
        text: 'Processing',
        spinner: 'el-icon-loading'
      })
      this.close()
        .then(data => {
          loading.close()
          this.success(data.id)
        })
        .catch(() => loading.close())
    },
    async success (id) {
      this.$message({
        message: 'Operation successful',
        type: 'success'
      })

      await this.init(id)
      this.bus.$emit('order-line-changed')
    },
    async handleSendXero () {
      const loading = this.$loading({
        lock: true,
        text: 'Processing',
        spinner: 'el-icon-loading'
      })
      this.sendXero()
        .then(data => {
          loading.close()
          this.success(data.id)
        })
        .catch(() => loading.close())
    },
    async markAsUnsend () {
      const loading = this.$loading({
        lock: true,
        text: 'Processing',
        spinner: 'el-icon-loading'
      })
      this.recallFromXero()
        .then(data => {
          loading.close()
          this.success(data.id)
        })
        .catch(() => loading.close())
    }
  },
  beforeRouteUpdate (to, from, next) {
    // just use `this`
    // console.log(to)
    this.routeName = to.params.routeName
    if (to.params.id !== from.params.id) {
      this.init(to.params.id)
    }
    next()
  },
  inject: ['bus']

  // provide () {
  //   return {
  //     bus: this.bus,
  //     routeName: this.routeName
  //   }
  // }
}
</script>

<style lang="scss" scoped>
.search-area {
  background-color: #fff;
}
.list {
  margin-top: 40px;
  background-color: #ffffff;
}
.btn {
  height: 32px;
  margin-left: 12px;
  padding: 0 16px;
  line-height: 32px;
}
.actions-btns-container {
  display: flex;
  margin-right: 12px;
}

.page-wrapper {
  max-width: 1678px;
}
.tags-container {
  text-align: center;
  margin-left: 8px;
  text-indent: 0;
}
</style>
